import { api, handleApiError } from '../client'
import type {
  TemplateShareLink,
  CreateShareLinkRequest,
  ShareLinkAccess,
} from '../types'

export const templateShareLinkService = {
  /**
   * Gets all share links for a template
   */
  async getShareLinks(
    templateId: string,
    includeRevoked: boolean = false
  ): Promise<TemplateShareLink[]> {
    try {
      const response = await api.get<TemplateShareLink[]>(
        `/v1/templates/${templateId}/share-links`,
        { params: { includeRevoked } }
      )
      return response.data
    } catch (error) {
      throw new Error(handleApiError(error))
    }
  },

  /**
   * Creates a new share link for a template
   */
  async createShareLink(
    templateId: string,
    request: CreateShareLinkRequest
  ): Promise<TemplateShareLink> {
    try {
      const response = await api.post<TemplateShareLink>(
        `/v1/templates/${templateId}/share-links`,
        request
      )
      return response.data
    } catch (error) {
      throw new Error(handleApiError(error))
    }
  },

  /**
   * Revokes a share link
   */
  async revokeShareLink(templateId: string, linkId: string): Promise<void> {
    try {
      await api.delete(`/v1/templates/${templateId}/share-links/${linkId}`)
    } catch (error) {
      throw new Error(handleApiError(error))
    }
  },

  /**
   * Validates a share link token (public endpoint)
   */
  async validateShareLink(
    token: string,
    email?: string
  ): Promise<ShareLinkAccess> {
    try {
      const response = await api.get<ShareLinkAccess>(`/v1/shared/${token}`, {
        params: email ? { email } : undefined,
      })
      return response.data
    } catch (error) {
      throw new Error(handleApiError(error))
    }
  },
}
